export const parseFormattedNumber = (formattedNumber: string): number => {
  const number = parseFloat(formattedNumber?.replace(/,/g, ''));
  return Math.round(number);
};
